import { Stack, Text } from "flicket-ui";
import PriceOrFree from "../../common/PriceOrFree";
import { PriceInfoProps } from "../types";
import { useOrganization } from "~hooks";
import { isChilliPeppersFlexiMembershipHack } from "~lib";

/**
 * Component to display price information based on current state
 */
export const PriceInfo = ({
  isExchangeFlow,
  ticketsLoading,
  hasSelection,
  showFees,
  cart,
  ownedTicketsExchangeValue,
}: PriceInfoProps) => {
  const { organization } = useOrganization();

  if (isExchangeFlow && ticketsLoading) {
    return null;
  }

  if (hasSelection) {
    if (isExchangeFlow) {
      const isLesserExchangeValue =
        cart.total < ownedTicketsExchangeValue &&
        !isChilliPeppersFlexiMembershipHack(organization.id);

      return (
        <>
          <Text variant="header.Minor">Difference to pay</Text>
          <Stack gap="1/2" direction="horizontal" alignItems="baseline">
            <Text variant="header.S">
              <PriceOrFree
                price={cart.total}
                currency={organization.currency}
              />
            </Text>
            <Text variant="small">Including fees</Text>
          </Stack>
          {isLesserExchangeValue && (
            <Text variant="small">
              You have selected a lower-priced value.
              <br />
              The difference won&apos;t be refunded.
            </Text>
          )}
        </>
      );
    }

    return (
      <>
        <Text variant="header.S">
          <PriceOrFree price={cart.total} currency={organization.currency} />
        </Text>
        {showFees && cart.total > 0 && (
          <Text variant="small">Including fees</Text>
        )}
      </>
    );
  }

  return null;
};
